import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import useWindowSize from '../../../../hooks/useWindowSize';
import './RewardDetailSkeleton.scss';

export default function RewardDetailSkeleton() {
  const isMobile = useWindowSize();
  return (
    <div className="RewardDetailSkeletonWrapper">
      <Skeleton height={isMobile ? 150 : 200} className="banner" />
      <Skeleton width={200} className="margin_tb_16" />
      <Skeleton height={40} width={300} className="margin_b_16" />

      <div className="cardDetailSection">
        <div className="imageSection">
          <div className="titleSection">
            <div className="imageContainer">
              <Skeleton width={isMobile ? 300 : 380} height={260} className="margin_b_8" />
              <Skeleton height={30} width={200} />
              <Skeleton count={5} />
              <div className="text">
                <Skeleton height={30} width={30} />
                <Skeleton height={30} width={200} />
              </div>
              <div className="text">
                <Skeleton height={30} width={30} />
                <Skeleton height={30} width={200} />
              </div>
              <div className="text">
                <Skeleton height={30} width={30} />
                <Skeleton height={30} width={200} />
              </div>
            </div>

            <div className="cardContainerSection">
              <Skeleton height={40} width={200} />
              <Skeleton height={30} />
              <Skeleton count={5} />
              <div className="cardDetail">
                <Skeleton height={30} width={30} />
                <Skeleton height={30} width={200} />
              </div>
              <div className="cardDetail">
                <Skeleton height={30} width={30} />
                <Skeleton height={30} width={200} />
              </div>
              <div className="cardDetail">
                <Skeleton height={30} width={30} />
                <Skeleton height={30} width={200} />
              </div>
              <div className="cardDetail">
                <Skeleton height={30} width={30} />
                <Skeleton height={30} width={200} />
              </div>
              <Skeleton height={30} width={200} />
              <Skeleton count={4} />
            </div>
          </div>
        </div>

        <div className="infoSection"><Skeleton height={400} className="margin_b_16" /></div>
      </div>

      <Skeleton className="margin_tb_8" />
      <Skeleton count={3} className="margin_tb_8" />
      <Skeleton height={150} className="bottomSection" />
    </div>
  );
};
